/** Keeps the collection/search toolbar below the header that is actually pinned. */
class CollectionGridToolbar extends HTMLElement {
  /** @type {ResizeObserver | undefined} */
  #resizeObserver;
  /** @type {MutationObserver | undefined} */
  #mutationObserver;
  /** @type {AbortController | undefined} */
  #controller;
  /** @type {Element | null} */
  #header = null;

  connectedCallback() {
    const group = document.getElementById('header-group');
    if (!group) return;

    this.#controller = new AbortController();
    this.#resizeObserver = new ResizeObserver(this.#updateOffset);
    this.#resizeObserver.observe(group);
    this.#mutationObserver = new MutationObserver(this.#updateOffset);
    this.#mutationObserver.observe(group, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-sticky-enabled', 'data-sticky-state', 'sticky'],
    });
    window.addEventListener('resize', this.#updateOffset, { signal: this.#controller.signal });
    this.#updateOffset();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#resizeObserver?.disconnect();
    this.#mutationObserver?.disconnect();
    this.#header = null;
  }

  #updateOffset = () => {
    const group = document.getElementById('header-group');
    const header = group?.querySelector('header-component') ?? null;
    if (header !== this.#header) {
      if (this.#header) this.#resizeObserver?.unobserve(this.#header);
      this.#header = header;
      if (header) this.#resizeObserver?.observe(header);
    }

    let height = 0;
    // The custom header pins the whole group, including its announcement bars.
    if (group && getComputedStyle(group).position === 'sticky') {
      height = group.getBoundingClientRect().height;
    } else if (header?.matches('[sticky="always"], [sticky="scroll-up"][data-sticky-state="active"]')) {
      // Native headers pin only their header section; announcements scroll away.
      height = header.getBoundingClientRect().height;
    }
    this.style.setProperty('--collection-toolbar-header-offset', `${Math.ceil(height)}px`);
  };
}

if (!customElements.get('collection-grid-toolbar')) {
  customElements.define('collection-grid-toolbar', CollectionGridToolbar);
}
